export default __webpack_public_path__ + "static/media/DoubleUp_ Banner Pop Up V1.cd0cfc7f.jpg";